const ITEMS = [
  "Private Estates",
  "High-Profile Events",
  "Nutritional Curation",
  "Michelin-Trained",
  "New York City",
  "The Hamptons",
];

function Sequence() {
  return (
    <div className="flex items-center shrink-0">
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center shrink-0">
          <span className="text-[11px] uppercase tracking-[0.45em] text-[#EAE6DF]/50 px-10">
            {item}
          </span>
          <span className="h-px w-10 bg-white/20" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <div
      data-testid="marquee-section"
      className="overflow-hidden border-b border-white/10 py-7 select-none"
      aria-hidden="true"
    >
      <div className="marquee-track flex w-max">
        <Sequence />
        <Sequence />
      </div>
    </div>
  );
}
